import { memo, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { logCallingError } from 'calling-error-reporting/report/error';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILink from 'UIComponents/link/UILink';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUIErrorMessage = styled(UIErrorMessage).withConfig({
  displayName: "InternalWidgetError__StyledUIErrorMessage",
  componentId: "sc-1224ge0-0"
})(["img{margin-bottom:15px;}"]);
function CallWidgetError({
  title,
  body,
  errorMessage,
  onClick
}) {
  const titleText = title || /*#__PURE__*/_jsx(FormattedMessage, {
    message: "callHostWidget.widgetError.title"
  });
  const bodyText = body || /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "callHostWidget.widgetError.body_jsx",
    elements: {
      UILink
    },
    options: {
      onClick
    }
  });
  useMemo(() => errorMessage && logCallingError({
    errorMessage
  }), [errorMessage]);
  return /*#__PURE__*/_jsx(StyledUIErrorMessage, {
    illustration: "errors/general",
    illustrationProps: {
      width: 80
    },
    title: /*#__PURE__*/_jsx("div", {
      className: "is--heading-4",
      children: titleText
    }),
    className: "p-x-4 m-y-3",
    children: bodyText
  });
}
export default /*#__PURE__*/memo(CallWidgetError);